import "./CountryInfo.scss"
import { useEffect, useRef, useState } from "react"
import CountryDataManager, { Country } from "../Data/country-manager"

function CountryInfo({ selectedCountryCode, langcode }: any) {

  let [countryData, setCountryData] = useState(null as Country|null)

  const countryDataInstance = useRef(null as CountryDataManager|null)
  useEffect(() => {
    if (!selectedCountryCode) return
    
    (async () => {
      const instance = await CountryDataManager.getInstance()
      countryDataInstance.current = instance
      setCountryData(instance.getCountry(selectedCountryCode, langcode))
    })();
  }, [selectedCountryCode, langcode])


  const getExcerpt = (str: string, limit: number) => {
    if (str == null) return "";
    var shortText = str;
    return shortText.slice(0, shortText.lastIndexOf(' ', limit)) + '...';
  }

  if(countryData == null) return <>Loading...</>
  return (
    <div className="country-block">
      <div className="country-flag">
        {countryData.flag_flat &&
          <img src={countryData.flag_flat} alt={countryData.name} title={countryData.name} />
        }
      </div>
      <div className="country-content">
        <div>
          <h2 className="country-title">{countryData.name}</h2>
          <p className="country-excerpt">{getExcerpt(countryData.description, 180)}</p>
        </div>
        <a className="country-link" href={countryData.link}>See more &rarr;</a>
      </div>
    </div>
  )


}


export default CountryInfo

